import {
  AboutTwlType,
  WhiskyLoversPageType,
  GuidePageType,
  WhiskyHubType,
  PartnersPageType,
  RetailPartnersPageType,
  IndustryPartnersPageType,
  FeaturedBrandType,
} from '../types/index';
import {axiosClient} from '../axios';
import {
  convertFiltersToSearchString,
  FiltersOf,
  getPaginatedFiltersMapping,
  getViewKeyHeader,
  MaybePaginatedGetter,
  ViewKeyOptions,
} from '../utils/index';
import {handleParams} from '../utils/fetchParamters';

export const getAboutTwl = async (viewKey?: string): Promise<AboutTwlType> => {
  const {data} = await axiosClient.get<AboutTwlType>('/community/about-twl/', {
    headers: getViewKeyHeader(viewKey),
  });
  return data;
};

export const getWhiskyLoversPage = async (
  viewKey?: string,
): Promise<WhiskyLoversPageType> => {
  const {data} = await axiosClient.get<WhiskyLoversPageType>(
    '/community/whisky-lovers/',
    {
      headers: getViewKeyHeader(viewKey),
    },
  );
  return data;
};

export const getGuidePageBySlug = async (
  slug: string,
): Promise<GuidePageType> => {
  const {data} = await axiosClient.get<GuidePageType>(
    `community/guides/${slug}/`,
  );
  return data;
};

export const getWhiskyHubPage = async (
  viewKey?: string,
): Promise<WhiskyHubType> => {
  const {data} = await axiosClient.get<WhiskyHubType>(
    '/community/whisky-hub/',
    {
      headers: getViewKeyHeader(viewKey),
    },
  );
  return data;
};

export const getPartnersPage = async (
  viewKey?: string,
): Promise<PartnersPageType> => {
  const {data} = await axiosClient.get<PartnersPageType>(
    '/community/partners-page/',
    {
      headers: getViewKeyHeader(viewKey),
    },
  );
  return data;
};

export interface PartnersPageFilterParamsType {
  is_online?: boolean;
  order_by?: string;
  states?: Array<string>;
}

export const getRetailPartnersPage = async (
  params?: PartnersPageFilterParamsType,
  viewKey?: string,
): Promise<RetailPartnersPageType> => {
  const {data} = await axiosClient.get<RetailPartnersPageType>(
    `/community/retail-partners-page/?${
      handleParams(params) ? handleParams(params) : ''
    }`,
    {
      headers: getViewKeyHeader(viewKey),
    },
  );
  return data;
};

export const getIndustryPartnersPage = async (
  params?: PartnersPageFilterParamsType,
  viewKey?: string,
): Promise<IndustryPartnersPageType> => {
  const {data} = await axiosClient.get<IndustryPartnersPageType>(
    `/community/industry-partners-page/?${
      handleParams(params) ? handleParams(params) : ''
    }`,
    {
      headers: getViewKeyHeader(viewKey),
    },
  );
  return data;
};

const featuredBrandsFiltersMapping = getPaginatedFiltersMapping({
  excludeSlug: 'exclude_slug',
  order: 'ordering',
});

export const getFeaturedBrands: MaybePaginatedGetter<
  FeaturedBrandType,
  FiltersOf<typeof featuredBrandsFiltersMapping>
> = async (
  filters: FiltersOf<typeof featuredBrandsFiltersMapping>,
  options: ViewKeyOptions,
) => {
  const {data} = await axiosClient.get(
    `community/featured-brands/${convertFiltersToSearchString(
      filters,
      featuredBrandsFiltersMapping,
    )}`,
    {headers: getViewKeyHeader(options?.viewKey)},
  );
  return data;
};

export const getFeaturedBrandBySlug = async (
  slug: string,
  viewKey: string,
): Promise<FeaturedBrandType> => {
  const {data} = await axiosClient.get<FeaturedBrandType>(
    `community/featured-brands/${slug}/`,
    {
      headers: getViewKeyHeader(viewKey),
    },
  );
  return data;
};
